import { render, staticRenderFns } from "./GlicemiaMediaEstimadaHemoglobinaGlicada.vue?vue&type=template&id=b6e59788"
import script from "./GlicemiaMediaEstimadaHemoglobinaGlicada.vue?vue&type=script&lang=js"
export * from "./GlicemiaMediaEstimadaHemoglobinaGlicada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports